import React, { useState, useEffect } from "react";
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import MUIDataTable, { DefaultTableBody } from "mui-datatables";
import { Routes, Route, useNavigate } from "react-router-dom";
import useSave from "../../Hooks/useSave";
import useDatatableAddon from "../../Hooks/useDatatableAddon";
import useAlert from "../../Hooks/useAlerts";

export default function Users() {
  const navigate = useNavigate();
  const { fetchGraphql, DialogSave } = useSave();
  const [data, setData] = useState([]);
  const [roles, setRoles] = useState([]);
  const [addAlert, Feedback] = useAlert();

  const addonOptions = {
    record: {
      messageId: `new${data.length + 1}`,
      message: "",
      startDate: "",
      endDate: "",
    },
    focus: 1,
    edit: (tableMeta) => {},
    save: (tableMeta) => {
      const copyState = [...data];

      const message = copyState.find(
        (item) => item["messageId"] === tableMeta.rowData[0]
      );

      const { messageId, ...newMessage } = message;

      if (message.messageId.includes("new")) {
        // console.log("new");
        return fetchGraphql({
          query: `mutation createMessage($message: inputMessage) {
            createMessage(message: $message)
          }`,
          variables: { message: newMessage },
        }).then((result) => {
          message.messageId = result.data.createMessage;

          setData(copyState);

          return Promise.resolve("done");
        });
      } else {
        // console.log("old");
        return fetchGraphql({
          query: `mutation UpdateMessage($messageId: ID, $message: inputMessage) {
            updateMessage(messageId: $messageId, message: $message)
          }`,
          variables: {
            message: newMessage,
            messageId: message.messageId,
          },
        }).then((result) => {
          return Promise.resolve("done");
        });
      }
    },
    delete: (tableMeta) => {
      // console.log(tableMeta);
      fetchGraphql({
        query: `mutation DeleteMessage($messageId: ID) {
          deleteMessage(messageId: $messageId)
        }`,
        variables: { messageId: tableMeta.rowData[0] },
      });
    },
    rowsPerPage: 1000,
  };

  const [
    textField,
    selectField,
    newRecord,
    actions,
    options,
    checkboxField,
    multipleSelect,
    dateField,
  ] = useDatatableAddon(data, setData, "messageId", addonOptions);

  const columns = [
    {
      name: "messageId",
      options: {
        display: false,
      },
    },
    {
      name: "message",
      label: "Message",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "500px",
          };

          return textField(tableMeta, value, options, updateValue);
        },
      },
    },
    {
      name: "startDate",
      label: "Start Date",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "250px",
          };

          return dateField(tableMeta, value, options, updateValue);
        },
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "250px",
          };

          return dateField(tableMeta, value, options, updateValue);
        },
      },
    },
    { ...actions },
  ];

  useEffect(() => {
    fetchGraphql({
      query: `query Query {
          messages {
            messageId
            message
            startDate
            endDate
          }
        }`,
      variables: {},
    }).then((result) => {
      setData(result.data.messages);
    });

    return () => {};
  }, []);

  const handleFilterSubmit = (applyFilters) => {
    let filterList = applyFilters();

    // console.log(filterList);
    // this.setState({ isLoading: true });

    // // fake async request
    // this.xhrRequest(`/myApiServer?filters=${filterList}`, filterList).then(
    //   (res) => {
    //     this.setState({ isLoading: false, data: res.data });
    //   }
    // );
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Feedback />

      <Button
        variant="contained"
        sx={{ margin: "0px 0px 20px auto" }}
        onClick={() =>
          newRecord({
            messageId: `new${data.length + 1}`,
            message: "",
            startDate: "",
            endDate: "",
          })
        }
      >
        <DialogSave />
        <AddIcon />
        New Message
      </Button>

      <MUIDataTable
        title={"Users"}
        data={data}
        columns={columns}
        options={options}
      />
    </Box>
  );
}
